import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    prepareBulkProductUpdateDetails,
}

const prepareBulkProductUpdateDetails = (productsList, existingProductUpdates, designDetail) => {
    const productUpdates = existingProductUpdates || {};

    _.forEach(productsList, product => {
        prepareProductUpdateDetails(product, productUpdates, designDetail);
    });

    return productUpdates;
}

const prepareProductUpdateDetails = (product, productUpdates, designDetail) => {
    // const productUpdateDetail: any = {};
    const productUpdateDetail: any = productUpdates[product.id] || {};
    productUpdateDetail.id = product.id;
    productUpdateDetail.shopifyId = product.shopifyId;

    if (!_.isEmpty(product?.seo)) {
        productUpdateDetail.seo = {};
        if (product?.seo?.title) {
            productUpdateDetail.seo.title = product?.seo?.title;
        }

        if (product?.seo?.description) {
            productUpdateDetail.seo.description = product?.seo?.description;
        }
    }

    prepareProductDetail(productUpdateDetail, product, designDetail);

    if (!_.isEmpty(productUpdateDetail.seo) || !_.isEmpty(productUpdateDetail?.productType) || !_.isEmpty(productUpdateDetail?.descriptionHtml) ||
        !_.isEmpty(productUpdateDetail?.metafields)) {
        productUpdates[product.id] = productUpdateDetail;
    }
}

const prepareProductDetail = (productUpdateDetail, product, designDetail) => {
    if (_.isEmpty(product?.productType)) {
        productUpdateDetail.productType = designDetail.parent;
    }

    if (!_.isEmpty(product?.descriptionHtml)) {
        productUpdateDetail.descriptionHtml = product.descriptionHtml;
    }

    prepareProductMetaFields(productUpdateDetail, product, designDetail);
}

const prepareProductMetaFields = (productUpdateDetail, product, designDetail) => {
    const metaFields = [];
    const existingMetaFieldsMap = _.keyBy(product.metafields, 'key');

    const quoteName: any = {
        key: 'quote_name',
        namespace: 'genie',
        value: designDetail.quoteName,
    };

    const themeName: any = {
        key: 'theme_name',
        namespace: 'genie',
        value: designDetail.themeName,
    };

    if (!_.isEmpty(existingMetaFieldsMap)) {
        const quoteMetaField = existingMetaFieldsMap['quote_name'];
        const themeMetaField = existingMetaFieldsMap['theme_name'];

        if (!_.isEmpty(quoteMetaField)) {
            quoteName.id = quoteMetaField.shopifyId;
        }

        if (!_.isEmpty(themeMetaField)) {
            themeName.id = themeMetaField.shopifyId;
        }
    }

    metaFields.push(quoteName);
    metaFields.push(themeName);

    productUpdateDetail.metafields = metaFields;
}
